module.exports = __webpack_public_path__ + "images/photo-editing-945d3da18327e7c60d80735531df50d9.svg";